import React from "react";
import Ripples from "react-ripples";

const ActionButtons = ({
  handlePrevious,
  onSubmit,
  isFormValid,
  previousLabel,
  submitLabel,
}) => {
  return (
    <div className="absolute bottom-0 left-0 w-full flex items-center justify-end pt-8 p-6 gap-6 border-t border-[#E4E7EC] bg-white">
      <div>
        <Ripples color="#FFFFFF40" during={600} className="rounded-lg flex-1">
          <button
            className="contract-button-2 contract-button-2-outlined"
            filled={false}
            onClick={handlePrevious}
          >
            <h5>{previousLabel}</h5>{" "}
          </button>
        </Ripples>
      </div>

      <div>
        <Ripples color="#FFFFFF40" during={600} className="rounded-lg flex-1">
          <button
            className={`contract-button-2 contract-button-2-filled ${
              isFormValid ? "opacity-100" : "opacity-50"
            }`}
            filled={true}
            onClick={onSubmit}
          >
            <h5>{submitLabel}</h5>{" "}
          </button>
        </Ripples>
      </div>
    </div>
  );
};

export default ActionButtons;
